// components/PolicyAmountRow.tsx

import { formatAmountByConfig } from "@/shared/utils/amountFormat";
import { PolicyAmountRowProps } from "../../types/policyTypes";

const PolicyAmountLabel = ({
  label,
  total = false,
}: Pick<PolicyAmountRowProps, "label" | "total">) => (
  <span
    className={
      total
        ? " shrink-0 text-[15px] font-bold text-theme-text-soft"
        : " shrink-0 text-[13px] font-bold text-theme-text-soft"
    }
  >
    {label}
  </span>
);

const PolicyAmountValue = ({
  value,
  currencySymbol,
  total = false,
}: Pick<PolicyAmountRowProps, "value" | "currencySymbol" | "total">) => (
  <span
    className={
      total
        ? "flex-1 text-right text-[18px] font-black text-theme-primary"
        : "flex-1 text-right text-[13px] font-bold text-theme-text"
    }
  >
    {currencySymbol} {formatAmountByConfig(value, { fallback: "0.00" })}
  </span>
);

const PolicyAmountRow = ({ label, value, currencySymbol, total = false }: PolicyAmountRowProps) => {
  return (
    <div className="flex items-start">
      <PolicyAmountLabel label={label} total={total} />
      <PolicyAmountValue value={value} currencySymbol={currencySymbol} total={total} />
    </div>
  );
};

export default PolicyAmountRow;
